import React, { useRef, useState } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { Collapse } from "react-bootstrap";
import ProfileInfo from "./ProfileInfo";
import Footer from "./Footer";

const StarSidebar = () => {
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const fileRef = useRef();

  const [liveChatSection, setLiveChatSection] = useState(false);
  const [learningSession, setLearningSession] = useState(false);
  const [fangroup, setFanGroup] = useState(false);
  const [meetupSession, setMeetupSession] = useState(false);
  const [souvenir, setSouvenir] = useState(false);
  const [schedule, setSchedule] = useState(false);
  const [greetingSession, setGreetingSession] = useState(false);
  const [post, setPost] = useState(false);
  const [promotional, setPromotional] = useState(false);
  const [promoVideos, setPromoVideos] = useState(false);
  const [qna, setQnA] = useState(false);

  //assigning location variable
  const location = useLocation();
  const { pathname } = location;
  const url = pathname.split("/superstar/");

  return (
    <nav className="sb-sidenav accordion sb-sidenav-dark" id="sidenavAccordion">
      <div className="sb-sidenav-menu custom-nav-scroll">
        <div className="nav">
          <ProfileInfo />

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Core
          </div>

          <Link
            className={
              url[1] === "dashboard" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar/dashboard"
          >
            <span className="">
              <i className="fa fa-cart-plus" aria-hidden="true"></i> &nbsp;
              Dashboard
            </span>
          </Link>

          <Link
            className={
              url[1] === "e-wallet" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar/e-wallet"
          >
            <span className="">
              <i class="fa-solid fa-wallet"></i> E-Wallet
            </span>
          </Link>

          <div
            className="nav-link cursor-pointer"
            onClick={() => setSchedule(!schedule)}
            aria-controls="example-collapse-text"
            aria-expanded={schedule}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-calendar-alt"></i> &nbsp;
            </div>
            Schedule
            {schedule ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={schedule}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "schedule-create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/schedule-create"
              >
                <span className="child-cat">
                  <i className="fas fa-calendar-alt"></i> &nbsp; Schedule Create
                </span>
              </Link>
              <Link
                className={
                  url[1] === "schedule-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/schedule-list"
              >
                <span className="child-cat">
                  <i className="fa fa-list"></i> &nbsp; Schedule List
                </span>
              </Link>
            </div>
          </Collapse>

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Promo Videos
          </div>

          {/* promo videos */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setPromoVideos(!promoVideos)}
            aria-controls="example-collapse-text"
            aria-expanded={promoVideos}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-video"></i> &nbsp;
            </div>
            Promo Videos
            {promoVideos ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={promoVideos}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "promo-videos"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/promo-videos"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>
              <Link
                className={
                  url[1] === "upload/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/upload/promoVideo"
              >
                <span className="child-cat">
                  <i className="fas fa-edit" aria-hidden="true"></i> &nbsp;
                  Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "pending/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/pending/promoVideo"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "approved/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/approved/promoVideo"
              >
                <span className="child-cat">
                  <i class="fa-brands fa-get-pocket"></i> &nbsp; Approved
                </span>
              </Link>

              <Link
                className={
                  url[1] === "live/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/live/promoVideo"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>

              <Link
                className={
                  url[1] === "rejected/promoVideo"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/rejected/promoVideo"
              >
                <span className="child-cat">
                  <i className="fas fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          <div
            className="nav-link cursor-pointer"
            onClick={() => setPost(!post)}
            aria-controls="example-collapse-text"
            aria-expanded={post}
          >
            <div className="sb-nav-link-icon">
              <i className="fa fa-book" aria-hidden="true"></i> &nbsp;
            </div>
            Post
            {post ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={post} className="childcat">
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "post"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/post"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "post/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/post/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "post/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/post/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "post/approved"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/post/approved"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>
            </div>
          </Collapse>

          {/* Post End */}

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Event Management
          </div>
          {/* liveChatSection */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setLiveChatSection(!liveChatSection)}
            aria-controls="example-collapse-text"
            aria-expanded={liveChatSection}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-comment-alt"></i> &nbsp;
            </div>
            Live Chat
            {liveChatSection ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={liveChatSection} className="childcat">
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "live-chat"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/live-chat"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>
              <Link
                className={
                  url[1] === "live-chat/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/live-chat/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>
              <Link
                className={
                  url[1] === "live-chat/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/live-chat/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>
              <Link
                className={
                  url[1] === "live-chat/approved"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/live-chat/approved"
              >
                <span className="child-cat">
                  <i class="fa-brands fa-get-pocket"></i> &nbsp; Approved
                </span>
              </Link>
              <Link
                className={
                  url[1] === "live-chat/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/live-chat/completed"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Completed
                </span>
              </Link>
              <Link
                className={
                  url[1] === "live-chat/rejected"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/live-chat/rejected"
              >
                <span className="child-cat">
                  <i className="fa fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          {/* QnA */}

          <div
            className="nav-link cursor-pointer"
            onClick={() => setQnA(!qna)}
            aria-controls="example-collapse-text"
            aria-expanded={qna}
          >
            <div className="sb-nav-link-icon">
              <i class="fa-solid fa-person-circle-question"></i> &nbsp;
            </div>
            QnA
            {qna ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={qna} className="childcat">
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "qna/dashboard"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/qna/dashboard"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/qna/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/qna/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/live"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/qna/live"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live
                </span>
              </Link>

              <Link
                className={
                  url[1] === "qna/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/qna/completed"
              >
                <span className="child-cat">
                  <i className="fas fa-check" aria-hidden="true"></i> &nbsp;
                  Completed
                </span>
              </Link>
            </div>
          </Collapse>

          {/* End QnA */}

          {/* meetupSession */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setMeetupSession(!meetupSession)}
            aria-controls="example-collapse-text"
            aria-expanded={meetupSession}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-handshake"></i> &nbsp;
            </div>
            Meetup Session
            {meetupSession ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={meetupSession}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "meetup-events/dashboard"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/meetup-events/dashboard"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/meetup-events/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Create
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/meetup-events/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/approved"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/meetup-events/approved"
              >
                <span className="child-cat">
                  <i class="fa-brands fa-get-pocket"></i> &nbsp; Approved
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/meetup-events/completed"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Completed
                </span>
              </Link>
              <Link
                className={
                  url[1] === "meetup-events/rejected"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/meetup-events/rejected"
              >
                <span className="child-cat">
                  <i className="fa fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          <div
            className="nav-link cursor-pointer"
            onClick={() => setGreetingSession(!greetingSession)}
            aria-controls="example-collapse-text"
            aria-expanded={greetingSession}
          >
            <div className="sb-nav-link-icon">
              <i class="fa-solid fa-gift"></i> &nbsp;
            </div>
            Greetings
            {greetingSession ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={greetingSession}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "greetings"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/greetings"
              >
                <span className="child-cat">
                  <i className="fas fa-edit" aria-hidden="true"></i> &nbsp;
                  Create
                </span>
              </Link>
              <Link
                className={
                  url[1] === "greetings-registered-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/greetings-registered-list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-address-card"></i> &nbsp; Registered
                  list
                </span>
              </Link>
              <Link
                className={
                  url[1] === "greetings-completed-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/greetings-completed-list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Completed
                  list
                </span>
              </Link>
              <Link
                className={
                  url[1] === "greetings-forwarded-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/greetings-forwarded-list"
              >
                <span className="child-cat">
                  <i class="fa-sharp fa-solid fa-share"></i> &nbsp; Forwarded List
                </span>
              </Link>
            </div>
          </Collapse>

          {/* learningSession */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setLearningSession(!learningSession)}
            aria-controls="example-collapse-text"
            aria-expanded={learningSession}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-chalkboard-teacher"></i> &nbsp;
            </div>
            Learning Session
            {learningSession ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={learningSession}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "learning-session"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/create"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session/create"
              >
                <span className="child-cat">
                  <i className="fas fa-edit" aria-hidden="true"></i> &nbsp;
                  Create
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/pending"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session/pending"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/approved"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session/approved"
              >
                <span className="child-cat">
                  <i class="fa-brands fa-get-pocket"></i> &nbsp; Approved
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/evaluation"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session/evaluation"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-dna"></i> &nbsp; Evaluation
                </span>
              </Link>

              <Link
                className={
                  url[1] === "learning-session/completed"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session/completed"
              >
                <span className="child-cat">
                  <i className="fas fa-check" aria-hidden="true"></i> &nbsp;
                  Completed
                </span>
              </Link>
              <Link
                className={
                  url[1] === "learning-session/show-result"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session/show-result"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-square-poll-vertical"></i> &nbsp;
                  Result
                </span>
              </Link>
              <Link
                className={
                  url[1] === "learning-session/rejected"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/learning-session/rejected"
              >
                <span className="child-cat">
                  <i className="fa fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>
            </div>
          </Collapse>

          {/* Star Showcase start*/}
          <div className="sb-sidenav-menu-heading custom-heading-menu">
            E-Showcase
          </div>

          <Link
            className={
              url[1] === "marketplace" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar/marketplace"
          >
            <span className="">
              <i className="fa fa-line-chart" aria-hidden="true"></i> &nbsp;
              Marketplace
            </span>
          </Link>

          <div
            className="nav-link cursor-pointer"
            onClick={() => setSouvenir(!souvenir)}
            aria-controls="example-collapse-text"
            aria-expanded={souvenir}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-handshake"></i> &nbsp;
            </div>
            Souvenir
            {souvenir ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={souvenir}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "souvenir"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/souvenir"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Souvenir
                </span>
              </Link>
              <Link
                className={
                  url[1] === "souvenir/register/list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/souvenir/register/list"
              >
                <span className="child-cat">
                  <i className="fas fa-edit"></i> &nbsp; Register User
                </span>
              </Link>
              <Link
                className={
                  url[1] === "souvenir/payment/list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/souvenir/payment/list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-cart-shopping"></i> &nbsp; User Order
                </span>
              </Link>
              <Link
                className={
                  url[1] === "souvenir/payment/due-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/souvenir/payment/due-list"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-money-check-dollar"></i> &nbsp; User Due
                  Payment
                </span>
              </Link>
            </div>
          </Collapse>

          <Link
            className={
              url[1] === "auction" ? "nav-link active-nav" : "nav-link"
            }
            to="/superstar/auction"
          >
            <span className="">
              <i className="fa fa-cart-plus" aria-hidden="true"></i> &nbsp;
              Auction
            </span>
          </Link>

          {/* Star Showcase End */}

          {/* Fan Group */}

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Fan Group
          </div>
          <div
            className="nav-link cursor-pointer"
            onClick={() => setFanGroup(!fangroup)}
            aria-controls="example-collapse-text"
            aria-expanded={fangroup}
          >
            <div className="sb-nav-link-icon">
              <i className="fas fa-chalkboard-teacher"></i> &nbsp;
            </div>
            Fan Group
            <i className="fa-solid fa-angle-down left"></i>
          </div>
          <Collapse in={fangroup}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "fan-group"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/fan-group"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>

              <Link
                className={
                  url[1] === "fan-group-accepted"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/fan-group-accepted"
                state={{ from: "Accepted" }}
              >
                <span className="child-cat">
                  <i class="fa-solid fa-clipboard-check"></i> &nbsp; Accepted
                </span>
              </Link>

              <Link
                className={
                  url[1] === "fan-group-rejected"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/fan-group-rejected"
              >
                <span className="child-cat">
                  <i className="fa fa-trash"></i> &nbsp; Rejected
                </span>
              </Link>

              <Link
                className={
                  url[1] === "fan-group-invitation"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/fan-group-invitation"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-credit-card"></i> &nbsp; Invitation
                </span>
              </Link>

              {/*
          <Link className={ url[1]==="approved-fan-group" ? "AudAdmin nav-link active-nav" : "AudAdmin nav-link" }
            to="/superstar/approved-fan-group">
          <span className="child-cat">
            <i className="fas fa-check" aria-hidden="true"></i> &nbsp;
            Approved
          </span>
          </Link> */}
            </div>
          </Collapse>

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Audition Management
          </div>

          {/* Audition */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setOpen(!open)}
            aria-controls="example-collapse-text"
            aria-expanded={open}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-handshake"></i> &nbsp;
            </div>
            Audition
            {open ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={open || ["audition"].includes(url[1])}>
            <div id="example-collapse-text subcat">
              <Link
                className="AudAdmin nav-link"
                to="/superstar/audition/dashboard"
              >
                <span className="child-cat">
                  <i className="fa-solid fa-gauge"></i> &nbsp; Dashboard
                </span>
              </Link>
              <Link
                className={
                  url[1] === "audition"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/audition"
              >
                <span className="child-cat">
                  <i class="fa-solid fa-satellite-dish"></i> &nbsp; Live Events
                </span>
              </Link>
              <Link
                className={
                  url[1] === "audition/pending-post"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/audition/pending-post"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending Auditions
                </span>
              </Link>

              {/* <Link
                className={
                  url[1] === "audition/pending-promo-auditions"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/audition/pending-promo-auditions"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i> &nbsp;
                  Pending Promo
                </span>
              </Link> */}

              <div className=" accordion-item ps-3 custom-nav-bg ">
                <div className="accordion-header" id="headingThree">
                  <button
                    className="px-3 py-2 accordion-button collapsed btnAdminnav2"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    <i className="fa-solid fa-atom"></i> &nbsp; Round
                    Instruction
                  </button>
                </div>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse  bg_black"
                  aria-labelledby="headingThree"
                  data-bs-parent="#accordionExample"
                >
                  <Link
                    className={
                      url[1] === "audition/round-instruction-video"
                        ? "AudAdmin nav-link active-nav text-black"
                        : "AudAdmin nav-link"
                    }
                    to="/superstar/audition/round-instruction-video"
                  >
                    <div className="sb-nav-link-icon">
                      <i className="fa-solid fa-calendar"></i>
                    </div>
                    Pending
                  </Link>
                  <Link
                    className={
                      url[1] === "audition/round-instruction-video-accepted"
                        ? "AudAdmin nav-link active-nav text-black"
                        : "AudAdmin nav-link"
                    }
                    to="/superstar/audition/round-instruction-video-accepted"
                  >
                    <div className="sb-nav-link-icon">
                      <i className="fa-solid fa-calendar"></i>
                    </div>
                    Accepted
                  </Link>
                </div>
              </div>
            </div>
          </Collapse>

          {/* Audition Promotional Video */}
          <div
            className="nav-link cursor-pointer"
            onClick={() => setPromotional(!promotional)}
            aria-controls="example-collapse-text"
            aria-expanded={promotional}
          >
            <div className="sb-nav-link-icon">
              <i className="far fa-handshake"></i> &nbsp;
            </div>
            Promotional Video
            {promotional ? (
              <i className="fa-solid fa-angle-up left"></i>
            ) : (
              <i className="fa-solid fa-angle-down left"></i>
            )}
          </div>
          <Collapse in={promotional || ["audition"].includes(url[1])}>
            <div id="example-collapse-text subcat">
              <Link
                className={
                  url[1] === "audition/promotional-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/audition/promotional-list"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i>{" "}
                  &nbsp;List
                </span>
              </Link>

              <Link
                className={
                  url[1] === "audition/accepted-promotional-list"
                    ? "AudAdmin nav-link active-nav"
                    : "AudAdmin nav-link"
                }
                to="/superstar/audition/accepted-promotional-list"
              >
                <span className="child-cat">
                  <i className="fa fa-spinner" aria-hidden="true"></i>{" "}
                  &nbsp;Promotional List
                </span>
              </Link>
            </div>
          </Collapse>

          <div className="sb-sidenav-menu-heading custom-heading-menu">
            Others
          </div>

          {/* <Link className="nav-link" to="/superstar/progressbar">
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i> &nbsp;
            </div>
            Progress Bar
          </Link> */}

          {/* <Link className="nav-link" to="/superstar/upcoming-event">
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i> &nbsp;
            </div>
            Upcoming Events
          </Link> */}

          {/* <Link className="nav-link" to="/superstar/wallet">
            <div className="sb-nav-link-icon">
              <i className="fas fa-tachometer-alt"></i> &nbsp;
            </div>
            Wallet
          </Link> */}
          <Link className="nav-link" to="/superstar/profile-settings">
            <div className="sb-nav-link-icon">
              <i class="fa-solid fa-gear"></i> &nbsp;
            </div>
            Settings
          </Link>
        </div>
      </div>

      <Footer />
    </nav>
  );
};

export default StarSidebar;
